import { X } from 'lucide-react'
import { useEffect, type ReactNode } from 'react'

export function Modal({ open, title, children, onClose, size = 'normal' }: { open: boolean; title: string; children: ReactNode; onClose: () => void; size?: 'normal' | 'wide' }) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && onClose()
    if (open) document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])
  if (!open) return null
  return <div className="modal-backdrop" role="presentation" onMouseDown={event => event.target === event.currentTarget && onClose()}>
    <section className={`modal ${size === 'wide' ? 'modal-wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
      <header><div><span className="eyebrow">PRIME SQUAD</span><h2>{title}</h2></div><button className="icon-button" onClick={onClose} aria-label="Закрыть"><X/></button></header>
      {children}
    </section>
  </div>
}
